exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-button {\n  background-color: #f5f5f5 !important;\n  border: 2px solid #ccc !important;\n  color: black !important;\n  border-radius: 20px;\n  padding: 10px 20px;\n  cursor: pointer;\n  outline: none;\n}\n\n.icon-button:hover {\n  background-color: #e0e0e0 !important;\n}\n\n.icon-button:active {\n  background-color: #d5d5d5 !important;\n}", ""]);

// exports
